// src/components/admin/onboarding/onboardingTheme.js
// Single source of truth for the onboarding redesign's color palette.
// Returns the right tokens for the active theme (light/dark) so every
// component in the redesign stays in lock-step with the rest of the app.
export const palette = (isDark) => isDark ? ({
    appBg:       '#0a0f1c',
    sectionBg:   '#0f172a',
    surface:     '#111827',
    surface2:    '#1f2937',
    surfaceMute: '#0b1220',
    border:      '#1f2937',
    borderSoft:  '#1f2937',
    divider:     '#1f2937',

    textPrimary: '#f3f4f6',
    textSecondary: '#9ca3af',
    textMuted:   '#6b7280',

    inputBg:     '#0b1220',
    inputBorder: '#374151',
    inputText:   '#f3f4f6',
    inputPh:     '#6b7280',

    pillGrayBg:  '#1f2937', pillGrayFg: '#d1d5db', pillGrayBd: '#374151',
    pillBlueBg:  'rgba(37,99,235,0.15)',  pillBlueFg:  '#93c5fd', pillBlueBd: 'rgba(37,99,235,0.35)',
    pillGreenBg: 'rgba(22,163,74,0.18)',  pillGreenFg: '#86efac', pillGreenBd:'rgba(22,163,74,0.4)',
    pillAmberBg: 'rgba(245,158,11,0.18)', pillAmberFg: '#fcd34d', pillAmberBd:'rgba(245,158,11,0.4)',
    pillRedBg:   'rgba(239,68,68,0.18)',  pillRedFg:   '#fca5a5', pillRedBd:  'rgba(239,68,68,0.4)',
    pillDarkBg:  '#f3f4f6',               pillDarkFg:  '#111827', pillDarkBd: '#e5e7eb',

    btnPrimaryBg: '#2563eb', btnPrimaryFg: 'white',  btnPrimaryBd: '#2563eb',
    btnSecondBg:  '#111827', btnSecondFg:  '#f3f4f6', btnSecondBd:  '#374151',
    btnGhostFg:   '#d1d5db',
    btnDangerBg:  '#1f1316', btnDangerFg:  '#fca5a5', btnDangerBd:  'rgba(239,68,68,0.4)',
    btnSuccessBg: '#16a34a', btnSuccessFg: 'white',
    btnDarkBg:    '#f3f4f6', btnDarkFg:    '#111827', btnDarkBd:    '#f3f4f6',
    btnGoldBg:    '#eab308', btnGoldFg:    '#1a1306',

    // Status row backgrounds (translucent tints so the surface shows through)
    docDoneBg:   'rgba(22,163,74,0.10)',  docDoneBd: 'rgba(22,163,74,0.32)',
    docPendBg:   'rgba(37,99,235,0.10)',  docPendBd: 'rgba(37,99,235,0.32)',
    docEmptyBg:  '#0b1220',               docEmptyBd: '#374151',

    progressTrack: '#1f2937',

    welcomeBannerBg: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #eab308 130%)',
    helpCardBg:      'linear-gradient(135deg, #0b0f1a 0%, #1e1b4b 100%)',

    privacyBg:    'rgba(37,99,235,0.10)', privacyBd: 'rgba(37,99,235,0.32)', privacyFg: '#bfdbfe',
    autosaveBg:   'rgba(245,158,11,0.10)', autosaveBd: 'rgba(245,158,11,0.32)', autosaveFg: '#fcd34d',
    successBg:    'rgba(22,163,74,0.10)',  successBd: 'rgba(22,163,74,0.32)', successFg: '#86efac',
    warnBg:       'rgba(245,158,11,0.10)', warnBd: 'rgba(245,158,11,0.32)', warnFg: '#fcd34d',
    selectedRow:  'rgba(37,99,235,0.14)',
    rowHover:     'rgba(255,255,255,0.04)',
    chipActiveBg: '#f3f4f6', chipActiveFg: '#111827', chipActiveBd: '#f3f4f6',
    chipBg:       '#111827', chipFg: '#d1d5db', chipBd: '#374151',
    cardShadow:   '0 1px 2px rgba(0,0,0,0.35)',
}) : ({
    appBg:       '#f9fafb',
    sectionBg:   '#f9fafb',
    surface:     'white',
    surface2:    '#fafbfc',
    surfaceMute: '#f3f4f6',
    border:      '#e5e7eb',
    borderSoft:  '#f3f4f6',
    divider:     '#f3f4f6',

    textPrimary: '#111827',
    textSecondary: '#374151',
    textMuted:   '#6b7280',

    inputBg:     'white',
    inputBorder: '#d1d5db',
    inputText:   '#111827',
    inputPh:     '#9ca3af',

    pillGrayBg: '#f3f4f6', pillGrayFg: '#374151', pillGrayBd: '#e5e7eb',
    pillBlueBg: '#eff6ff', pillBlueFg: '#1d4ed8', pillBlueBd: '#dbeafe',
    pillGreenBg:'#f0fdf4', pillGreenFg:'#15803d', pillGreenBd:'#dcfce7',
    pillAmberBg:'#fffbeb', pillAmberFg:'#b45309', pillAmberBd:'#fef3c7',
    pillRedBg:  '#fef2f2', pillRedFg:  '#b91c1c', pillRedBd:  '#fee2e2',
    pillDarkBg: '#111827', pillDarkFg: '#f9fafb', pillDarkBd: '#111827',

    btnPrimaryBg: '#2563eb', btnPrimaryFg: 'white',   btnPrimaryBd: '#2563eb',
    btnSecondBg:  'white',   btnSecondFg:  '#111827', btnSecondBd:  '#d1d5db',
    btnGhostFg:   '#374151',
    btnDangerBg:  'white',   btnDangerFg: '#b91c1c',  btnDangerBd:  '#fecaca',
    btnSuccessBg: '#16a34a', btnSuccessFg: 'white',
    btnDarkBg:    '#111827', btnDarkFg:    'white',   btnDarkBd:    '#111827',
    btnGoldBg:    '#eab308', btnGoldFg:    '#1a1306',

    docDoneBg:   '#f0fdf4',  docDoneBd:  '#dcfce7',
    docPendBg:   '#eff6ff',  docPendBd:  '#dbeafe',
    docEmptyBg:  'white',    docEmptyBd: '#d1d5db',

    progressTrack: '#f3f4f6',

    welcomeBannerBg: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #eab308 130%)',
    helpCardBg:      'linear-gradient(135deg, #0b0f1a 0%, #1e1b4b 100%)',

    privacyBg: '#eff6ff', privacyBd: '#dbeafe', privacyFg: '#1e3a8a',
    autosaveBg:'#fefce8', autosaveBd:'#fef08a', autosaveFg:'#854d0e',
    successBg: '#f0fdf4', successBd: '#bbf7d0', successFg: '#14532d',
    warnBg:    '#fefce8', warnBd:    '#fef08a', warnFg:    '#854d0e',
    selectedRow: '#eff6ff',
    rowHover:   '#fafbfc',
    chipActiveBg: '#111827', chipActiveFg: 'white', chipActiveBd: '#111827',
    chipBg:       'white',   chipFg: '#374151',     chipBd: '#e5e7eb',
    cardShadow:   '0 1px 2px rgba(0,0,0,0.04)',
});
